import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  HostBinding, Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { AbstractControl, FormControlName } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'pseic-form-field',
  templateUrl: './pseic-form-field.component.html',
  styleUrls: ['./pseic-form-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PseicFormFieldComponent implements OnInit, AfterContentInit, OnDestroy {

  @HostBinding('class.pseic-form-field') readonly pseicFormFieldClass = true;

  /** FormControl status (default: valid) */
  controlStatus: string = 'valid';

  /** Label name (Optional) */
  @Input() label: string = null;

  /** Label "for" attribute is set by default as FormControl name (Optional) */
  @Input() labelFor: string = null;

  /** Disable FormControl */
  @Input() disabled = false;
  @Input() readonly = false;
  @Input() showRequiredAsteriskWithoutLabel = false;
  @Input() component: any = null;
  @Input() dataTestId: string = '';

  /** Skip actions on FormControl */
  @Input() skipControl = false;

  /** Resize (stretch down) the component when validation error is shown */
  @Input() resizeOnError = true;

  @ContentChild(FormControlName)
  controlName: FormControlName;

  isRequiredAsterisk = false;

  /** Global subscription */
  private subs = new Subscription();


  constructor(
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (this.component) {
      this.readonly = this.component.readonly;
    }
  }

  ngAfterContentInit(): void {
    if (!this.skipControl && this.controlName) {
      this.controlStatus = this.controlName.status || 'valid';
      this.subs.add(
        this.controlName.statusChanges.subscribe((status: string) => {
          this.controlStatus = status.toLowerCase() || 'valid';
          this.isRequiredAsterisk = this.checkIsValidatorRequiredExist();
          this.cd.markForCheck();
        })
      );
      this.subs.add(
        this.controlName.valueChanges.subscribe(_ => {
          this.cd.markForCheck();
        })
      );
      this.isRequiredAsterisk = this.checkIsValidatorRequiredExist();
      this.checkDisabled();
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  /**
   * Checking is FormControl has validator required
   */
  checkIsValidatorRequiredExist(): boolean {

    if (!this.controlName || this.readonly || this.disabled || this.controlName.control.disabled) {
      return false;
    }
    if (this.controlName.control.validator) {
      const validator = this.controlName.control.validator({} as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }
    return false;
  }


  /**
   * Disabled FormControl
   */
  private checkDisabled(): void {
    if (this.disabled) {
      this.controlName.control.disable({ emitEvent: false });
    }
  }

}
